module.exports = __webpack_public_path__ + "static/qsociety_book-e0fcacad89d83c8797411c7d35d80e42.jpg";